/* Nomax Instant Search */
(function(){
  var WORKER_URL="https://shops-search.nomax-search-api.workers.dev";
  var STORE=document.querySelector('meta[name="nmx-store"]');
  if(!STORE)return;
  STORE=STORE.content;

  var inputs=document.querySelectorAll('input[type="search"],input[name="q"],.search__input');
  inputs.forEach(function(input){
    var wrap=input.closest('form')||input.parentElement;
    wrap.style.position='relative';
    wrap.classList.add('nmx-search-wrap');

    var results=document.createElement('div');
    results.className='nmx-results';
    wrap.appendChild(results);

    var timer=null;
    input.addEventListener('input',function(){
      clearTimeout(timer);
      var q=input.value.trim();
      if(q.length<2){results.classList.remove('nmx-open');results.innerHTML='';return;}
      timer=setTimeout(function(){
        fetch(WORKER_URL+'/search?store='+encodeURIComponent(STORE)+'&q='+encodeURIComponent(q)+'&limit=6')
          .then(function(r){return r.json()})
          .then(function(data){
            if(!data.results||data.results.length===0){
              results.innerHTML='<div class="nmx-no-results">Ingen resultater for «'+q+'»</div>';
              results.classList.add('nmx-open');
              return;
            }
            var html='';
            data.results.forEach(function(p){
              var img=p.image?'<img src="'+p.image+'" alt="">':'<div style="width:48px;height:48px;background:#f0f0f0;border-radius:4px"></div>';
              html+='<a class="nmx-result" href="'+p.url+'">'
                +img
                +'<div class="nmx-result-info"><div class="nmx-result-title">'+p.title+'</div>'
                +'<div class="nmx-result-vendor">'+p.vendor+'</div></div>'
                +'<div class="nmx-result-price">'+p.price+'</div></a>';
            });
            if(data.total>6){
              html+='<a class="nmx-view-all" href="/search?q='+encodeURIComponent(q)+'">Se alle '+data.total+' resultater →</a>';
            }
            results.innerHTML=html;
            results.classList.add('nmx-open');
          }).catch(function(){});
      },250);
    });

    // Close on outside click
    document.addEventListener('click',function(e){
      if(!wrap.contains(e.target)){results.classList.remove('nmx-open');}
    });

    // Close on escape
    input.addEventListener('keydown',function(e){
      if(e.key==='Escape')results.classList.remove('nmx-open');
    });
  });
})();
